function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 10v150h123l-13-31V10z",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M121.5 125c-.828 0-1.5.653-1.5 1.458 0 .188.038.374.111.547l-.015.005 13.52 32.113.01-.003c.237.533.776.879 1.374.88.625 0 1.184-.378 1.403-.948l.01.003 13.5-32.067-.016-.006c.067-.167.102-.345.103-.524 0-.805-.672-1.458-1.5-1.458zM125 0c-2.77 0-5 2.23-5 5v15h30v60c0 2.77 2.23 5 5 5s5-2.23 5-5V15c0-2.77-2.23-5-5-5h-5V5c0-2.77-2.23-5-5-5z",
  fill: "#85939f"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M120 30v85h30V94.139a14.938 14.938 0 0 1-10-14.123V30z",
  fill: "#48ac87"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  width: 80,
  height: 10,
  x: 15,
  y: 55,
  ry: 0,
  fill: "#cfcfcf"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  width: 25,
  height: 20,
  x: 70,
  y: 25,
  ry: 0,
  fill: "#cfcfcf"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  width: 80,
  height: 10,
  x: 15,
  y: 75,
  ry: 0,
  fill: "#cfcfcf"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M15 141c4 0 4.345.153 9-2 4-2 5.943-4.07 9-7 3.386-2.738 4.227-6.349 6.623-9.629.633-.866 2.782-4.784 2.38-4-1.465 3.591-3.035 7.539-4.16 11.188-.27 2.704-.693 6.649.734 9.2 1.511 2.457 5.758 2.429 7.776.686 3.785-2.37 6.43-6.512 9.056-9.565 3.235-4.71 5.664-9.57 8.543-14.412.653-1.066 2.875-5.974 1.541-2.826-1.813 4.986-3.803 10.696-5.228 15.74-.206 3.654-.93 7.027.45 10.572 1.065 2.463 4.862 2.613 7.526.708 2.597-1.948 3.47-2.761 4.974-5.311.636-1.181 2.306-6.28 1.206-3.223-.827 2.54-.647 5.462 1.579 7.871 1.441 1.442 8.595 1.844 14.069 1.957 2.121.043 13.745.044 14.931.044",
  fill: "none",
  stroke: "#3c3c3c",
  strokeWidth: 8
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M0 10v150h123.127l-2.102-5H5V15h105v-5z",
  fill: "#4e6476"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#c24e34",
  d: "M15 25h45v20H15z"
});

function SvgReleaseauth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReleaseauth);
export default __webpack_public_path__ + "static/media/releaseauth.201916dcd395ce9cb80d4eb50f1d2994.svg";
export { ForwardRef as ReactComponent };